import React from "react";
import PropTypes from "prop-types";
import Util from "../../../common/util";

function AngelInterest(props) {
  const { interest } = props;

  return (
    <React.Fragment>
      { interest && (
        <div className='row'>
          <div className='col-sm-4'>
            <h3 className='pb-2'>興味のある事業・サービス</h3>
          </div>
          <div className='col-sm-8'>
            <p>
              {Util.newLineToBrTag(interest)}
            </p>
          </div>
        </div>
      )}
    </React.Fragment>
  );
}

AngelInterest.propTypes = {
  interest: PropTypes.string
};

AngelInterest.defaultProps = {
  interest: null
};

export default AngelInterest;
